var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "qce" },
    [
      _c(
        "div",
        {
          ref: "stickyAnchor",
          staticClass: "qce-sticky-anchor",
          style: _vm.stickyPinned
            ? { minHeight: _vm.stickyPinHeight + "px" }
            : null,
        },
        [
          _c(
            "div",
            {
              ref: "stickyStack",
              staticClass: "qce-sticky-stack",
              class: { "is-pinned": _vm.stickyPinned },
              style: _vm.stickyPinStyle,
            },
            [
              _c(
                "div",
                {
                  staticClass: "qce-sticky",
                  class: {
                    "qce-sticky--recurring": _vm.stickyScope === "recurring",
                  },
                },
                [
                  _vm.hasRecurringSals
                    ? _c("div", { staticClass: "qce-sticky__scope" }, [
                        _c(
                          "button",
                          {
                            staticClass: "qce-scope-btn",
                            class: {
                              "is-active": _vm.stickyScope === "onetime",
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.stickyScope = "onetime"
                              },
                            },
                          },
                          [_vm._v("Una tantum")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "qce-scope-btn",
                            class: {
                              "is-active": _vm.stickyScope === "recurring",
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.stickyScope = "recurring"
                              },
                            },
                          },
                          [_vm._v("Contratto")]
                        ),
                      ])
                    : _c("div", { staticClass: "qce-sticky__kicker" }, [
                        _c("span", { staticClass: "qce-sticky__label" }, [
                          _vm._v("Ambito"),
                        ]),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Una tantum")]),
                      ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "qce-sticky__item" }, [
                    _c("span", { staticClass: "qce-sticky__label" }, [
                      _vm._v("Ore"),
                    ]),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatHours(_vm.stickyTotals.hours))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "qce-sticky__item" }, [
                    _c("span", { staticClass: "qce-sticky__label" }, [
                      _vm._v("Costo"),
                    ]),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(
                        "€ " +
                          _vm._s(_vm.formatMoney(_vm.stickyTotals.actualCost))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.stickyScope === "onetime"
                    ? _c("div", { staticClass: "qce-sticky__item" }, [
                        _c("span", { staticClass: "qce-sticky__label" }, [
                          _vm._v("Sconto tot."),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "qce-money qce-money--dark" },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("€"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.headerDiscount,
                                  expression: "headerDiscount",
                                  modifiers: { number: true },
                                },
                              ],
                              staticClass:
                                "form-control input-sm qce-sticky__input",
                              attrs: {
                                type: "number",
                                step: "0.01",
                                min: "0",
                                title: "Sconto totale offerta (€)",
                              },
                              domProps: { value: _vm.headerDiscount },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.headerDiscount = _vm._n(
                                      $event.target.value
                                    )
                                  },
                                  _vm.touch,
                                ],
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]
                        ),
                      ])
                    : _c("div", { staticClass: "qce-sticky__item" }, [
                        _c("span", { staticClass: "qce-sticky__label" }, [
                          _vm._v("Sconto righe"),
                        ]),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            "€ " +
                              _vm._s(
                                _vm.formatMoney(_vm.stickyTotals.lineDiscount)
                              )
                          ),
                        ]),
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "qce-sticky__item qce-sticky__item--revenue",
                    },
                    [
                      _c("span", { staticClass: "qce-sticky__label" }, [
                        _vm._v("Netto"),
                      ]),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          "€ " +
                            _vm._s(
                              _vm.formatMoney(
                                _vm.stickyTotals.discountedRevenue
                              )
                            )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "qce-sticky__item",
                      class:
                        "qce-sticky__item--" +
                        _vm.gmTone(
                          _vm.stickyTotals.gmPercent,
                          _vm.stickyTotals.actualCost,
                          _vm.stickyTotals.discountedRevenue
                        ),
                    },
                    [
                      _c("span", { staticClass: "qce-sticky__label" }, [
                        _vm._v("Margine"),
                      ]),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          "€ " +
                            _vm._s(_vm.formatMoney(_vm.stickyTotals.margin))
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "qce-sticky__item",
                      class:
                        "qce-sticky__item--" +
                        _vm.gmTone(
                          _vm.stickyTotals.gmPercent,
                          _vm.stickyTotals.actualCost,
                          _vm.stickyTotals.discountedRevenue
                        ),
                    },
                    [
                      _c("span", { staticClass: "qce-sticky__label" }, [
                        _vm._v("GM%"),
                      ]),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.formatGm(
                              _vm.stickyTotals.gmPercent,
                              _vm.stickyTotals.actualCost,
                              _vm.stickyTotals.discountedRevenue
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "qce-sticky__actions" }, [
                    _vm.dirty
                      ? _c("span", { staticClass: "qce-dirty" }, [
                          _vm._v("Non salvato"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-link qce-recalc-btn",
                        attrs: { type: "button" },
                        on: { click: _vm.openRecalcModal },
                      },
                      [
                        _vm._v(
                          "\n                    Ricalcola\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-success",
                        attrs: { type: "button" },
                        on: { click: _vm.submitQuote },
                      },
                      [_vm._v("\n                    Salva\n                ")]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.stickyScope === "recurring"
                ? _c("p", { staticClass: "qce-sticky__caption" }, [
                    _vm._v(
                      "\n            Valore contratto (ore, costi e ricavi × numero di periodi; max " +
                        _vm._s(_vm.maxRecurringPeriods) +
                        ").\n            Le righe sotto restano per periodo.\n        "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "qce-hint text-muted" }, [
        _vm._v("\n        Salvando si aggiorna l’offerta collegata.\n    "),
      ]),
      _vm._v(" "),
      _vm.showRecalcModal
        ? _c(
            "div",
            {
              staticClass: "qce-modal-backdrop",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeRecalcModal.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "qce-modal",
                  attrs: { role: "dialog", "aria-modal": "true" },
                },
                [
                  _c("div", { staticClass: "qce-modal__header" }, [
                    _c("h4", [_vm._v("Ricalcola ricavi")]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.closeRecalcModal },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "qce-modal__body" }, [
                    _c("p", [
                      _vm._v(
                        "Sovrascrive i ricavi di tutte le attività non opzionali. Salva dopo per persistarli sull’offerta."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Modalità *")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.recalcForm.mode,
                              expression: "recalcForm.mode",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.recalcForm,
                                "mode",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "ratecard" } }, [
                            _vm._v("Ratecard + markup su costi vivi"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "markup" } }, [
                            _vm._v("Markup"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.recalcForm.mode === "ratecard"
                        ? _c("small", { staticClass: "help-block" }, [
                            _vm._v(
                              "\n                        Ore: tariffa ratecard × ore. Costi vivi: markup sul costo.\n                    "
                            ),
                          ])
                        : _c("small", { staticClass: "help-block" }, [
                            _vm._v(
                              "\n                        Ore: costo orario risorsa × (1 + markup%). Costi vivi: stesso markup.\n                    "
                            ),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Markup (%) *")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.recalcForm.markup,
                            expression: "recalcForm.markup",
                            modifiers: { number: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", min: "0", step: "0.01" },
                        domProps: { value: _vm.recalcForm.markup },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.recalcForm,
                              "markup",
                              _vm._n($event.target.value)
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.enableRatecardRange &&
                    _vm.recalcForm.mode === "ratecard"
                      ? _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v(
                              "Percentuale ratecard (0% = min, 100% = max)"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "qce-modal__range" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.recalcForm.ratecardPercentage,
                                  expression: "recalcForm.ratecardPercentage",
                                  modifiers: { number: true },
                                },
                              ],
                              attrs: {
                                type: "range",
                                min: "0",
                                max: "100",
                                step: "1",
                              },
                              domProps: {
                                value: _vm.recalcForm.ratecardPercentage,
                              },
                              on: {
                                __r: function ($event) {
                                  _vm.$set(
                                    _vm.recalcForm,
                                    "ratecardPercentage",
                                    _vm._n($event.target.value)
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.recalcForm.ratecardPercentage) + "%"
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.recalcPreview
                      ? _c("div", { staticClass: "qce-recalc-preview" }, [
                          _vm._v(
                            "\n                    Ricavi netti attuali € " +
                              _vm._s(
                                _vm.formatMoney(_vm.recalcPreview.before)
                              ) +
                              "\n                    → € " +
                              _vm._s(_vm.formatMoney(_vm.recalcPreview.after)) +
                              "\n                    "
                          ),
                          _c(
                            "strong",
                            {
                              class:
                                _vm.recalcPreview.delta >= 0
                                  ? "qce-gm--ok"
                                  : "qce-gm--bad",
                            },
                            [
                              _vm._v(
                                "\n                        (" +
                                  _vm._s(
                                    _vm.recalcPreview.delta >= 0 ? "+" : ""
                                  ) +
                                  "€ " +
                                  _vm._s(
                                    _vm.formatMoney(_vm.recalcPreview.delta)
                                  ) +
                                  ")\n                    "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "qce-modal__footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: { click: _vm.closeRecalcModal },
                      },
                      [_vm._v("Annulla")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-warning",
                        attrs: { type: "button" },
                        on: { click: _vm.applyRecalc },
                      },
                      [_vm._v("Sovrascrivi ricavi")]
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "draggable",
        {
          attrs: {
            handle: ".qce-sal-drag",
            animation: 150,
            "ghost-class": "qce-sal--ghost",
          },
          on: { end: _vm.onSalsReorder },
          model: {
            value: _vm.sals,
            callback: function ($$v) {
              _vm.sals = $$v
            },
            expression: "sals",
          },
        },
        _vm._l(_vm.sals, function (sal, salIndex) {
          return _c(
            "div",
            {
              key: sal.client_key,
              staticClass: "qce-sal",
              class: {
                "qce-sal--optional": sal.is_optional,
                "qce-sal--recurring": sal.is_recurring,
              },
            },
            [
              _c("div", { staticClass: "qce-sal__header" }, [
                _c(
                  "span",
                  {
                    staticClass: "qce-sal-drag",
                    attrs: { title: "Trascina per riordinare il SAL" },
                  },
                  [_c("i", { staticClass: "fa fa-arrows" })]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "qce-sal__title-wrap" }, [
                  _c("label", [_vm._v("Titolo SAL *")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: sal.title,
                        expression: "sal.title",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", required: "" },
                    domProps: { value: sal.title },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(sal, "title", $event.target.value)
                        },
                        _vm.touch,
                      ],
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "qce-sal__flags" }, [
                  _c("label", { staticClass: "checkbox-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: sal.is_recurring,
                          expression: "sal.is_recurring",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(sal.is_recurring)
                          ? _vm._i(sal.is_recurring, null) > -1
                          : sal.is_recurring,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = sal.is_recurring,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    sal,
                                    "is_recurring",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    sal,
                                    "is_recurring",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(sal, "is_recurring", $$c)
                            }
                          },
                          _vm.touch,
                        ],
                      },
                    }),
                    _vm._v(" Ricorrente\n                    "),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "checkbox-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: sal.is_optional,
                          expression: "sal.is_optional",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(sal.is_optional)
                          ? _vm._i(sal.is_optional, null) > -1
                          : sal.is_optional,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = sal.is_optional,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    sal,
                                    "is_optional",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    sal,
                                    "is_optional",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(sal, "is_optional", $$c)
                            }
                          },
                          _vm.touch,
                        ],
                      },
                    }),
                    _vm._v(" Opzionale\n                    "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "checkbox-inline qce-sal__flag--quiet" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: sal.hide_price,
                            expression: "sal.hide_price",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(sal.hide_price)
                            ? _vm._i(sal.hide_price, null) > -1
                            : sal.hide_price,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = sal.hide_price,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      sal,
                                      "hide_price",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      sal,
                                      "hide_price",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(sal, "hide_price", $$c)
                              }
                            },
                            _vm.touch,
                          ],
                        },
                      }),
                      _vm._v(" Nascondi prezzo\n                    "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-xs btn-danger qce-sal__delete",
                      attrs: { type: "button", title: "Elimina SAL" },
                      on: {
                        click: function ($event) {
                          return _vm.removeSal(salIndex)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-trash" })]
                  ),
                ]),
              ]),
              _vm._v(" "),
              sal.is_recurring
                ? _c("div", { staticClass: "qce-sal__recurring" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: sal.recurring_period,
                            expression: "sal.recurring_period",
                          },
                        ],
                        staticClass: "form-control input-sm",
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                sal,
                                "recurring_period",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.onSalRecurringDatesEdited(salIndex)
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Periodo…"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "monthly" } }, [
                          _vm._v("Mensile"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "quarterly" } }, [
                          _vm._v("Trimestrale"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "semi-annual" } }, [
                          _vm._v("Semestrale"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "annual" } }, [
                          _vm._v("Annuale"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: sal.recurring_start_date,
                          expression: "sal.recurring_start_date",
                        },
                      ],
                      staticClass: "form-control input-sm",
                      attrs: { type: "text", placeholder: "Inizio d/m/Y" },
                      domProps: { value: sal.recurring_start_date },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              sal,
                              "recurring_start_date",
                              $event.target.value
                            )
                          },
                          function ($event) {
                            return _vm.onSalRecurringDatesEdited(salIndex)
                          },
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: sal.recurring_end_date,
                          expression: "sal.recurring_end_date",
                        },
                      ],
                      staticClass: "form-control input-sm",
                      attrs: { type: "text", placeholder: "Fine d/m/Y" },
                      domProps: { value: sal.recurring_end_date },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              sal,
                              "recurring_end_date",
                              $event.target.value
                            )
                          },
                          function ($event) {
                            return _vm.onSalRecurringDatesEdited(salIndex)
                          },
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "checkbox-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: sal.recurring_advance,
                            expression: "sal.recurring_advance",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(sal.recurring_advance)
                            ? _vm._i(sal.recurring_advance, null) > -1
                            : sal.recurring_advance,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = sal.recurring_advance,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      sal,
                                      "recurring_advance",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      sal,
                                      "recurring_advance",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(sal, "recurring_advance", $$c)
                              }
                            },
                            function ($event) {
                              return _vm.onSalRecurringDatesEdited(salIndex)
                            },
                          ],
                        },
                      }),
                      _vm._v(" Anticipata\n                "),
                    ]),
                    _vm._v(" "),
                    sal.recurring_period &&
                    sal.recurring_start_date &&
                    sal.recurring_end_date
                      ? _c("span", { staticClass: "qce-period-badge" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.periodLabel(null, sal)) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.salRecurringApplyPrompt[sal.client_key] &&
                    _vm.salHasActivities(sal)
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-xs btn-primary qce-sal__apply-recurring",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.applySalRecurringToAll(salIndex)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    Applica a tutte le attività\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "qce-colhead",
                  attrs: { "aria-hidden": "false" },
                },
                [
                  _c("span"),
                  _vm._v(" "),
                  _c("span"),
                  _vm._v(" "),
                  _c("span", [_vm._v("Prodotto")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Attività")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Risorsa")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Qty")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Unità")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "qce-colhead--num" }, [
                    _vm._v("Costo"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "qce-colhead--num" }, [
                    _vm._v("Ricavo"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "qce-colhead--num" }, [
                    _vm._v("Sconto"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "qce-colhead--num" }, [
                    _vm._v("GM"),
                  ]),
                  _vm._v(" "),
                  _c("span"),
                ]
              ),
              _vm._v(" "),
              _c(
                "draggable",
                {
                  staticClass: "qce-activities",
                  attrs: {
                    group: "quote-activity-blocks",
                    handle: ".qce-act-drag",
                    animation: 150,
                    "ghost-class": "qce-activity-block--ghost",
                  },
                  on: { end: _vm.onActivityBlocksReorder },
                  model: {
                    value: sal.activityBlocks,
                    callback: function ($$v) {
                      _vm.$set(sal, "activityBlocks", $$v)
                    },
                    expression: "sal.activityBlocks",
                  },
                },
                _vm._l(sal.activityBlocks, function (block, blockIndex) {
                  return _c(
                    "div",
                    { key: block.key, staticClass: "qce-activity-block" },
                    _vm._l(block.activities, function (activity, rowIndex) {
                      return _c(
                        "div",
                        {
                          key: activity.client_key,
                          staticClass: "qce-activity",
                          class: {
                            "qce-activity--optional": activity.is_optional,
                            "qce-activity--open":
                              rowIndex === 0 &&
                              _vm.isDetailsOpen(activity.client_key),
                            "qce-activity--continuation": rowIndex > 0,
                          },
                        },
                        [
                          _c("div", { staticClass: "qce-activity__main" }, [
                            rowIndex === 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "qce-act-drag",
                                    attrs: {
                                      title:
                                        "Trascina per riordinare o spostare in un altro SAL",
                                    },
                                  },
                                  [_c("i", { staticClass: "fa fa-arrows" })]
                                )
                              : _c("span", {
                                  staticClass: "qce-act-drag-spacer",
                                  attrs: { "aria-hidden": "true" },
                                }),
                            _vm._v(" "),
                            rowIndex === 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-xs btn-default qce-activity__toggle",
                                    attrs: {
                                      type: "button",
                                      title: _vm.isDetailsOpen(
                                        activity.client_key
                                      )
                                        ? "Nascondi dettagli"
                                        : "Mostra dettagli",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleDetails(
                                          activity.client_key
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa",
                                      class: _vm.isDetailsOpen(
                                        activity.client_key
                                      )
                                        ? "fa-chevron-up"
                                        : "fa-chevron-down",
                                    }),
                                  ]
                                )
                              : _c("span", {
                                  staticClass: "qce-activity__toggle-spacer",
                                  attrs: { title: "Risorsa aggiuntiva" },
                                }),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: activity.product_id,
                                    expression: "activity.product_id",
                                  },
                                ],
                                staticClass:
                                  "form-control input-sm qce-field-product",
                                attrs: { disabled: rowIndex !== 0 },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        activity,
                                        "product_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function ($event) {
                                      _vm.onProductOrTitleChange(
                                        salIndex,
                                        _vm.actIndexInSal(
                                          sal,
                                          blockIndex,
                                          rowIndex
                                        )
                                      )
                                    },
                                  ],
                                },
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v("Prodotto…"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.products, function (p) {
                                  return _c(
                                    "option",
                                    {
                                      key: "p-" + p.id,
                                      domProps: { value: p.id },
                                    },
                                    [_vm._v(_vm._s(p.name))]
                                  )
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: activity.title,
                                  expression: "activity.title",
                                },
                              ],
                              staticClass:
                                "form-control input-sm qce-field-title",
                              attrs: {
                                type: "text",
                                placeholder: "Attività",
                                readonly: rowIndex !== 0,
                              },
                              domProps: { value: activity.title },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      activity,
                                      "title",
                                      $event.target.value
                                    )
                                  },
                                  function ($event) {
                                    _vm.onProductOrTitleChange(
                                      salIndex,
                                      _vm.actIndexInSal(
                                        sal,
                                        blockIndex,
                                        rowIndex
                                      )
                                    )
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: activity.cost_id,
                                    expression: "activity.cost_id",
                                  },
                                ],
                                staticClass:
                                  "form-control input-sm qce-field-resource",
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        activity,
                                        "cost_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function ($event) {
                                      _vm.onActivityMetaChange(
                                        salIndex,
                                        _vm.actIndexInSal(
                                          sal,
                                          blockIndex,
                                          rowIndex
                                        )
                                      )
                                    },
                                  ],
                                },
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v("Risorsa…"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.costs, function (c) {
                                  return _c(
                                    "option",
                                    {
                                      key: "c-" + c.id,
                                      domProps: { value: c.id },
                                    },
                                    [_vm._v(_vm._s(c.title))]
                                  )
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: activity.quantity,
                                  expression: "activity.quantity",
                                  modifiers: { number: true },
                                },
                              ],
                              staticClass: "form-control input-sm qce-qty",
                              attrs: {
                                type: "number",
                                step: "0.01",
                                min: "0",
                                title: _vm.isOverhead(activity)
                                  ? "Overhead " +
                                    _vm.overheadPercent(activity) +
                                    "% ore SAL"
                                  : "Valore risorsa",
                                placeholder: _vm.isOverhead(activity)
                                  ? "Auto"
                                  : "Valore",
                                readonly: _vm.isOverhead(activity),
                                disabled: _vm.isOverhead(activity),
                              },
                              domProps: { value: activity.quantity },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      activity,
                                      "quantity",
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  function ($event) {
                                    _vm.onActivityMetaChange(
                                      salIndex,
                                      _vm.actIndexInSal(
                                        sal,
                                        blockIndex,
                                        rowIndex
                                      )
                                    )
                                  },
                                ],
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: activity.unit,
                                    expression: "activity.unit",
                                  },
                                ],
                                staticClass: "form-control input-sm qce-unit",
                                attrs: {
                                  title: "Unità di misura",
                                  disabled:
                                    !_vm.isTimeBased(activity) ||
                                    _vm.isOverhead(activity),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        activity,
                                        "unit",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function ($event) {
                                      _vm.onActivityMetaChange(
                                        salIndex,
                                        _vm.actIndexInSal(
                                          sal,
                                          blockIndex,
                                          rowIndex
                                        )
                                      )
                                    },
                                  ],
                                },
                              },
                              _vm._l(
                                _vm.unitOptionsFor(activity),
                                function (u) {
                                  return _c(
                                    "option",
                                    {
                                      key: u.value,
                                      domProps: { value: u.value },
                                    },
                                    [_vm._v(_vm._s(u.label))]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "qce-cost",
                                attrs: {
                                  title:
                                    "Costo effettivo (tariffa risorsa × ore + costi vivi)",
                                },
                              },
                              [
                                _vm._v(
                                  "€ " +
                                    _vm._s(
                                      _vm.formatMoney(
                                        rowIndex === 0
                                          ? _vm.groupLineCost(sal, activity)
                                          : _vm.lineCost(activity)
                                      )
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            rowIndex === 0
                              ? _c("div", { staticClass: "qce-money" }, [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [_vm._v("€")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: activity.revenue,
                                        expression: "activity.revenue",
                                        modifiers: { number: true },
                                      },
                                    ],
                                    staticClass:
                                      "form-control input-sm qce-revenue",
                                    attrs: {
                                      type: "number",
                                      step: "0.01",
                                      min: "0",
                                      title: "Ricavo (unificato per attività)",
                                      placeholder: "0",
                                    },
                                    domProps: { value: activity.revenue },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            activity,
                                            "revenue",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        function ($event) {
                                          _vm.onGroupRevenueChange(
                                            salIndex,
                                            _vm.actIndexInSal(
                                              sal,
                                              blockIndex,
                                              rowIndex
                                            )
                                          )
                                        },
                                      ],
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                ])
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "qce-revenue qce-revenue--shared",
                                    attrs: {
                                      title:
                                        "Ricavo unificato sull'attività principale",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "€ " +
                                        _vm._s(
                                          _vm.formatMoney(
                                            _vm.groupPrimary(sal, activity)
                                              .revenue
                                          )
                                        )
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            rowIndex === 0
                              ? _c("div", { staticClass: "qce-money" }, [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [_vm._v("€")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: activity.line_discount,
                                        expression: "activity.line_discount",
                                        modifiers: { number: true },
                                      },
                                    ],
                                    staticClass:
                                      "form-control input-sm qce-discount",
                                    attrs: {
                                      type: "number",
                                      step: "0.01",
                                      min: "0",
                                      title: "Sconto riga (€)",
                                      placeholder: "0",
                                    },
                                    domProps: { value: activity.line_discount },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            activity,
                                            "line_discount",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        function ($event) {
                                          _vm.onGroupCommercialChange(
                                            salIndex,
                                            _vm.actIndexInSal(
                                              sal,
                                              blockIndex,
                                              rowIndex
                                            )
                                          )
                                        },
                                      ],
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                ])
                              : _c(
                                  "span",
                                  {
                                    staticClass: "qce-discount-spacer",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [_vm._v("—")]
                                ),
                            _vm._v(" "),
                            rowIndex === 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "qce-gm",
                                    class: _vm.lineGmClass(sal, activity),
                                    attrs: {
                                      title: _vm.lineGmTitle(sal, activity),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatGm(
                                          _vm.lineGm(sal, activity),
                                          _vm.groupLineCost(sal, activity),
                                          _vm.activityNetRevenue(
                                            _vm.groupPrimary(sal, activity)
                                          )
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "qce-gm qce-gm--muted",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [_vm._v("—")]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "qce-activity__actions" },
                              [
                                rowIndex === 0 && !_vm.isOverhead(activity)
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-xs btn-success",
                                        attrs: {
                                          type: "button",
                                          title: "Aggiungi risorsa",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.addResource(
                                              salIndex,
                                              _vm.actIndexInSal(
                                                sal,
                                                blockIndex,
                                                rowIndex
                                              )
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-user-plus",
                                        }),
                                      ]
                                    )
                                  : _c("span", {
                                      staticClass: "qce-action-spacer",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-xs btn-danger",
                                    attrs: { type: "button", title: "Elimina" },
                                    on: {
                                      click: function ($event) {
                                        _vm.removeActivity(
                                          salIndex,
                                          _vm.actIndexInSal(
                                            sal,
                                            blockIndex,
                                            rowIndex
                                          )
                                        )
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "fa fa-trash" })]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          rowIndex === 0
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isDetailsOpen(
                                        activity.client_key
                                      ),
                                      expression:
                                        "isDetailsOpen(activity.client_key)",
                                    },
                                  ],
                                  staticClass: "qce-activity__details",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "qce-activity__details-row",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "qce-computed",
                                          attrs: { title: "Costo calcolato" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.formatHours(
                                                  activity.total_hours
                                                )
                                              ) +
                                              " h · € " +
                                              _vm._s(
                                                _vm.formatMoney(
                                                  activity.total_price
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                          activity.total_cost
                                            ? _c("small", [
                                                _vm._v(
                                                  " / vivi € " +
                                                    _vm._s(
                                                      _vm.formatMoney(
                                                        activity.total_cost
                                                      )
                                                    )
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { staticClass: "checkbox-inline" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: activity.is_optional,
                                                expression:
                                                  "activity.is_optional",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                activity.is_optional
                                              )
                                                ? _vm._i(
                                                    activity.is_optional,
                                                    null
                                                  ) > -1
                                                : activity.is_optional,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a =
                                                      activity.is_optional,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          activity,
                                                          "is_optional",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          activity,
                                                          "is_optional",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      activity,
                                                      "is_optional",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function ($event) {
                                                  _vm.onGroupCommercialChange(
                                                    salIndex,
                                                    _vm.actIndexInSal(
                                                      sal,
                                                      blockIndex,
                                                      rowIndex
                                                    )
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(
                                            " Opzionale\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { staticClass: "checkbox-inline" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: activity.hide_price,
                                                expression:
                                                  "activity.hide_price",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                activity.hide_price
                                              )
                                                ? _vm._i(
                                                    activity.hide_price,
                                                    null
                                                  ) > -1
                                                : activity.hide_price,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = activity.hide_price,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          activity,
                                                          "hide_price",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          activity,
                                                          "hide_price",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      activity,
                                                      "hide_price",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function ($event) {
                                                  _vm.onGroupCommercialChange(
                                                    salIndex,
                                                    _vm.actIndexInSal(
                                                      sal,
                                                      blockIndex,
                                                      rowIndex
                                                    )
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(
                                            " Nascondi prezzo\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { staticClass: "qce-notes-label" },
                                        [
                                          _vm._v(
                                            "Note\n                                    "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: activity.notes,
                                                expression: "activity.notes",
                                              },
                                            ],
                                            staticClass:
                                              "form-control input-sm",
                                            attrs: { type: "text" },
                                            domProps: { value: activity.notes },
                                            on: {
                                              input: [
                                                function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    activity,
                                                    "notes",
                                                    $event.target.value
                                                  )
                                                },
                                                function ($event) {
                                                  _vm.onGroupCommercialChange(
                                                    salIndex,
                                                    _vm.actIndexInSal(
                                                      sal,
                                                      blockIndex,
                                                      rowIndex
                                                    )
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  sal.is_recurring
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "qce-activity__recurring",
                                        },
                                        [
                                          _c(
                                            "small",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "Override ricorrenza attività:"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    activity.recurring_period,
                                                  expression:
                                                    "activity.recurring_period",
                                                },
                                              ],
                                              staticClass:
                                                "form-control input-sm",
                                              on: {
                                                change: [
                                                  function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      activity,
                                                      "recurring_period",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                  function ($event) {
                                                    _vm.onGroupCommercialChange(
                                                      salIndex,
                                                      _vm.actIndexInSal(
                                                        sal,
                                                        blockIndex,
                                                        rowIndex
                                                      )
                                                    )
                                                  },
                                                ],
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "" } },
                                                [_vm._v("Eredita dal SAL")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "monthly" } },
                                                [_vm._v("Mensile")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: { value: "quarterly" },
                                                },
                                                [_vm._v("Trimestrale")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "semi-annual",
                                                  },
                                                },
                                                [_vm._v("Semestrale")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "annual" } },
                                                [_vm._v("Annuale")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  activity.recurring_start_date,
                                                expression:
                                                  "activity.recurring_start_date",
                                              },
                                            ],
                                            staticClass:
                                              "form-control input-sm",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Inizio",
                                            },
                                            domProps: {
                                              value:
                                                activity.recurring_start_date,
                                            },
                                            on: {
                                              input: [
                                                function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    activity,
                                                    "recurring_start_date",
                                                    $event.target.value
                                                  )
                                                },
                                                function ($event) {
                                                  _vm.onGroupCommercialChange(
                                                    salIndex,
                                                    _vm.actIndexInSal(
                                                      sal,
                                                      blockIndex,
                                                      rowIndex
                                                    )
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  activity.recurring_end_date,
                                                expression:
                                                  "activity.recurring_end_date",
                                              },
                                            ],
                                            staticClass:
                                              "form-control input-sm",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Fine",
                                            },
                                            domProps: {
                                              value:
                                                activity.recurring_end_date,
                                            },
                                            on: {
                                              input: [
                                                function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    activity,
                                                    "recurring_end_date",
                                                    $event.target.value
                                                  )
                                                },
                                                function ($event) {
                                                  _vm.onGroupCommercialChange(
                                                    salIndex,
                                                    _vm.actIndexInSal(
                                                      sal,
                                                      blockIndex,
                                                      rowIndex
                                                    )
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { staticClass: "checkbox-inline" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      activity.recurring_advance,
                                                    expression:
                                                      "activity.recurring_advance",
                                                  },
                                                ],
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    activity.recurring_advance
                                                  )
                                                    ? _vm._i(
                                                        activity.recurring_advance,
                                                        null
                                                      ) > -1
                                                    : activity.recurring_advance,
                                                },
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      var $$a =
                                                          activity.recurring_advance,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              activity,
                                                              "recurring_advance",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              activity,
                                                              "recurring_advance",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          activity,
                                                          "recurring_advance",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                    function ($event) {
                                                      _vm.onGroupCommercialChange(
                                                        salIndex,
                                                        _vm.actIndexInSal(
                                                          sal,
                                                          blockIndex,
                                                          rowIndex
                                                        )
                                                      )
                                                    },
                                                  ],
                                                },
                                              }),
                                              _vm._v(
                                                " Anticipata\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "qce-sal__footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-info",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.addActivity(salIndex)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" Nuova attività\n                "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "qce-sal__totals" },
                  [
                    sal.is_optional
                      ? _c(
                          "span",
                          { staticClass: "qce-pill qce-pill--optional" },
                          [_vm._v("Escluso dai KPI")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    sal.is_recurring
                      ? [
                          _vm._v(
                            "\n                        Per periodo (" +
                              _vm._s(_vm.periodLabel(null, sal)) +
                              "):\n                        " +
                              _vm._s(
                                _vm.formatHours(_vm.salTotals(sal).hours)
                              ) +
                              " h ·\n                        costo € " +
                              _vm._s(
                                _vm.formatMoney(_vm.salTotals(sal).actualCost)
                              ) +
                              " ·\n                        ricavi € " +
                              _vm._s(
                                _vm.formatMoney(
                                  _vm.salTotals(sal).discountedRevenue
                                )
                              ) +
                              "\n                        · GM " +
                              _vm._s(
                                _vm.formatGm(
                                  _vm.salTotals(sal).gmPercent,
                                  _vm.salTotals(sal).actualCost,
                                  _vm.salTotals(sal).discountedRevenue
                                )
                              ) +
                              "\n                        "
                          ),
                          _c("span", { staticClass: "qce-sal__contract" }, [
                            _vm._v(
                              "\n                            Contratto:\n                            " +
                                _vm._s(
                                  _vm.formatHours(
                                    _vm.salContractTotals(sal).hours
                                  )
                                ) +
                                " h ·\n                            € " +
                                _vm._s(
                                  _vm.formatMoney(
                                    _vm.salContractTotals(sal).discountedRevenue
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]
                      : [
                          _vm._v(
                            "\n                        Totale SAL:\n                        " +
                              _vm._s(
                                _vm.formatHours(_vm.salTotals(sal).hours)
                              ) +
                              " h ·\n                        costo € " +
                              _vm._s(
                                _vm.formatMoney(_vm.salTotals(sal).actualCost)
                              ) +
                              " ·\n                        ricavi € " +
                              _vm._s(
                                _vm.formatMoney(
                                  _vm.salTotals(sal).discountedRevenue
                                )
                              ) +
                              "\n                        · GM " +
                              _vm._s(
                                _vm.formatGm(
                                  _vm.salTotals(sal).gmPercent,
                                  _vm.salTotals(sal).actualCost,
                                  _vm.salTotals(sal).discountedRevenue
                                )
                              ) +
                              "\n                    "
                          ),
                        ],
                  ],
                  2
                ),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-block btn-primary qce-add-sal",
          attrs: { type: "button" },
          on: { click: _vm.addSal },
        },
        [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Nuovo SAL\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "qce-hidden-fields", attrs: { "aria-hidden": "true" } },
        [
          _c("input", {
            attrs: { type: "hidden", name: "total_hours" },
            domProps: { value: _vm.totals.hours },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "total_price" },
            domProps: { value: _vm.totals.hoursCost },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "total_cost" },
            domProps: { value: _vm.totals.liveCost },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "header_discount" },
            domProps: { value: _vm.headerDiscount },
          }),
          _vm._v(" "),
          _vm._l(_vm.sals, function (sal, salIndex) {
            return [
              sal.id
                ? _c("input", {
                    key: "sid-" + sal.client_key,
                    attrs: {
                      type: "hidden",
                      name: "sals[" + salIndex + "][id]",
                    },
                    domProps: { value: sal.id },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                key: "snew-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][is_new]",
                },
                domProps: { value: sal.is_new ? 1 : 0 },
              }),
              _vm._v(" "),
              _c("input", {
                key: "spos-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][position]",
                },
                domProps: { value: salIndex },
              }),
              _vm._v(" "),
              _c("input", {
                key: "stitle-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][title]",
                },
                domProps: { value: sal.title },
              }),
              _vm._v(" "),
              _c("input", {
                key: "srec-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][is_recurring]",
                },
                domProps: { value: sal.is_recurring ? 1 : 0 },
              }),
              _vm._v(" "),
              _c("input", {
                key: "srp-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][recurring_period]",
                },
                domProps: { value: sal.recurring_period || "" },
              }),
              _vm._v(" "),
              _c("input", {
                key: "srs-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][recurring_start_date]",
                },
                domProps: { value: sal.recurring_start_date || "" },
              }),
              _vm._v(" "),
              _c("input", {
                key: "sre-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][recurring_end_date]",
                },
                domProps: { value: sal.recurring_end_date || "" },
              }),
              _vm._v(" "),
              _c("input", {
                key: "sra-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][recurring_advance]",
                },
                domProps: { value: sal.recurring_advance ? 1 : 0 },
              }),
              _vm._v(" "),
              _c("input", {
                key: "sth-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][salTotalHours]",
                },
                domProps: { value: _vm.salTotals(sal).hours },
              }),
              _vm._v(" "),
              _c("input", {
                key: "stc-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][salTotalCost]",
                },
                domProps: { value: _vm.salTotals(sal).liveCost },
              }),
              _vm._v(" "),
              _c("input", {
                key: "stp-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][salTotalPrice]",
                },
                domProps: { value: _vm.salTotals(sal).hoursCost },
              }),
              _vm._v(" "),
              _c("input", {
                key: "sopt-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][is_optional]",
                },
                domProps: { value: sal.is_optional ? 1 : 0 },
              }),
              _vm._v(" "),
              _c("input", {
                key: "shide-" + sal.client_key,
                attrs: {
                  type: "hidden",
                  name: "sals[" + salIndex + "][hide_price]",
                },
                domProps: { value: sal.hide_price ? 1 : 0 },
              }),
              _vm._v(" "),
              sal.id
                ? _c("input", {
                    key: "cso-" + sal.client_key,
                    attrs: {
                      type: "hidden",
                      name: "commercial_sals[" + sal.id + "][is_optional]",
                    },
                    domProps: { value: sal.is_optional ? 1 : 0 },
                  })
                : _vm._e(),
              _vm._v(" "),
              sal.id
                ? _c("input", {
                    key: "csh-" + sal.client_key,
                    attrs: {
                      type: "hidden",
                      name: "commercial_sals[" + sal.id + "][hide_price]",
                    },
                    domProps: { value: sal.hide_price ? 1 : 0 },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(sal.activities, function (activity, actIndex) {
                return [
                  activity.id
                    ? _c("input", {
                        key: "aid-" + activity.client_key,
                        attrs: {
                          type: "hidden",
                          name:
                            "sals[" +
                            salIndex +
                            "][sal_activities][" +
                            actIndex +
                            "][id]",
                        },
                        domProps: { value: activity.id },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    key: "anew-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][is_new]",
                    },
                    domProps: { value: activity.is_new ? 1 : 0 },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "apos-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][position]",
                    },
                    domProps: { value: actIndex },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "apid-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][product_id]",
                    },
                    domProps: { value: activity.product_id || "" },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "atitle-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][title]",
                    },
                    domProps: { value: activity.title },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "acid-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][cost_id]",
                    },
                    domProps: { value: activity.cost_id || "" },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "aqty-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][quantity]",
                    },
                    domProps: { value: activity.quantity },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "aunit-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][unit]",
                    },
                    domProps: { value: activity.unit || "hours" },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "anotes-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][notes]",
                    },
                    domProps: { value: activity.notes || "" },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "agrp-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][activity_group_id]",
                    },
                    domProps: { value: activity.activity_group_id || "" },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "ath-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][salActivityTotalHours]",
                    },
                    domProps: { value: activity.total_hours },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "atc-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][salActivityTotalCost]",
                    },
                    domProps: { value: activity.total_cost },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "atp-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][salActivityTotalPrice]",
                    },
                    domProps: { value: activity.total_price },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "arp-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][recurring_period]",
                    },
                    domProps: { value: activity.recurring_period || "" },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "ars-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][recurring_start_date]",
                    },
                    domProps: { value: activity.recurring_start_date || "" },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "are-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][recurring_end_date]",
                    },
                    domProps: { value: activity.recurring_end_date || "" },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "ara-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][recurring_advance]",
                    },
                    domProps: { value: activity.recurring_advance ? 1 : 0 },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "arev-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][revenue]",
                    },
                    domProps: {
                      value: _vm.isGroupPrimary(sal, actIndex)
                        ? activity.revenue
                        : 0,
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "ald-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][line_discount]",
                    },
                    domProps: {
                      value: _vm.isGroupPrimary(sal, actIndex)
                        ? activity.line_discount
                        : 0,
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "aopt-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][is_optional]",
                    },
                    domProps: { value: activity.is_optional ? 1 : 0 },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    key: "ahide-" + activity.client_key,
                    attrs: {
                      type: "hidden",
                      name:
                        "sals[" +
                        salIndex +
                        "][sal_activities][" +
                        actIndex +
                        "][hide_price]",
                    },
                    domProps: { value: activity.hide_price ? 1 : 0 },
                  }),
                  _vm._v(" "),
                  activity.id
                    ? [
                        _c("input", {
                          key: "cr-" + activity.client_key,
                          attrs: {
                            type: "hidden",
                            name:
                              "commercial_activities[" +
                              activity.id +
                              "][revenue]",
                          },
                          domProps: {
                            value: _vm.isGroupPrimary(sal, actIndex)
                              ? activity.revenue
                              : 0,
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          key: "cd-" + activity.client_key,
                          attrs: {
                            type: "hidden",
                            name:
                              "commercial_activities[" +
                              activity.id +
                              "][line_discount]",
                          },
                          domProps: {
                            value: _vm.isGroupPrimary(sal, actIndex)
                              ? activity.line_discount
                              : 0,
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          key: "co-" + activity.client_key,
                          attrs: {
                            type: "hidden",
                            name:
                              "commercial_activities[" +
                              activity.id +
                              "][is_optional]",
                          },
                          domProps: { value: activity.is_optional ? 1 : 0 },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          key: "ch-" + activity.client_key,
                          attrs: {
                            type: "hidden",
                            name:
                              "commercial_activities[" +
                              activity.id +
                              "][hide_price]",
                          },
                          domProps: { value: activity.hide_price ? 1 : 0 },
                        }),
                      ]
                    : _vm._e(),
                ]
              }),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }